import React from 'react';

const OrgProfileCard = ({org, handleOrgClick}) => {
    return (
        <div
            key={org.org_id}
            className="organization-tile"
            style={{
                flex: '1 1 calc(33.333% - 20px)', // 3 tiles per row with a 20px gap
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '20px',
                cursor: 'pointer',
                backgroundColor: '#213360',
                transition: 'background-color 0.3s, transform 0.3s, color 0.3s',
            }}
            onClick={() => handleOrgClick(org.org_id)}
        >
            <div
                style={{
                    fontSize: '2rem',
                    marginBottom: '10px',
                    color: 'white',
                }}
            >
                <i className="fa fa-wifi"></i>
            </div>
            <h5
                style={{
                    margin: 0,
                    textTransform: 'uppercase',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: 'white',
                }}
            >
                {org.org_name}
            </h5>
            <p style={{ 
                margin: '5px 0 0', 
                fontSize: '14px',
                color: '#21cdc0' 
            }}>
                {org.address}
            </p>
        </div>
    );
};

export default OrgProfileCard;